import React from 'react';

import styles from './Balloons.module.scss';

interface BalloonsProps {
  count?: number;
}

const calculateStyles = (index: number, count: number) => ({
  left: `calc(${index} * ${Math.trunc(100 / count)}% + 5%)`,
  animationDelay: `${Math.floor(Math.random() * 200 + 100)}ms`,
  animationDuration: `${Math.floor(Math.random() * 2000 + 1000)}ms`,
});

export default function Balloons({ count = 5 }: BalloonsProps) {
  return (
    <div className='w-full h-full absolute'>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={'balloons_' + index}
          style={{
            ...calculateStyles(index, count),
          }}
          className={styles.balloon}
        />
      ))}
    </div>
  );
}
